import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Tooltip } from '@99designs/react-components';
import ReactSlider from '@99designs/react-components/vendor/react-slider/react-slider';

import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement } from 'contest/components/brief/read-element';

export class SlidersElement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
        };
    }

    handleChange(sliderKey, newValue) {
        this.setState(
            {
                value: {
                    ...this.state.value,
                    [sliderKey]: newValue,
                },
            },
            () => {
                this.props.onChange(this.state.value, true);
            }
        );
    }

    render() {
        const { sliders, value } = this.props;
        return (
            <div>
                {Object.keys(sliders).map(key => {
                    const { min, max, minTooltip, maxTooltip } = sliders[key];
                    return (
                        <SliderField
                            key={key}
                            minLabel={min}
                            maxLabel={max}
                            minTooltip={minTooltip}
                            maxTooltip={maxTooltip}
                        >
                            <Slider
                                min={-5}
                                max={5}
                                defaultValue={value[key]}
                                onAfterChange={value => this.handleChange(key, value)}
                                disabled={this.props.readOnly}
                            />
                        </SliderField>
                    );
                })}
            </div>
        );
    }
}
SlidersElement.propTypes = {
    sliders: PropTypes.objectOf(
        PropTypes.shape({
            min: PropTypes.string.isRequired,
            max: PropTypes.string.isRequired,
            minTooltip: PropTypes.string,
            maxTooltip: PropTypes.string,
        })
    ).isRequired,
    value: PropTypes.objectOf(PropTypes.number).isRequired,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
};
SlidersElement.defaultProps = {
    readOnly: false,
    onChange: () => {},
};

export class EditSlidersElement extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.value !== nextProps.value;
    }

    handleChange(value) {
        this.props.onChange(value, true);
    }

    render() {
        return (
            <SlidersElement
                sliders={this.props.sliders}
                value={this.props.value}
                readOnly={false}
                onChange={this.handleChange}
            />
        );
    }
}
EditSlidersElement.propTypes = {
    value: PropTypes.object.isRequired,
    sliders: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

export const ConnectedEditSlidersElement = connectEditElementToBriefStore(
    EditSlidersElement,
    element => ({
        value: element.value,
        sliders: element.trans.sliders,
    })
);

export const ViewSlidersElement = connectReadElement(SlidersElement, element => ({
    value: element.value,
    sliders: element.trans.sliders,
    readOnly: true,
}));

const SliderFieldLabel = ({ label, tooltip }) => {
    if (tooltip) {
        return (
            <Tooltip tooltip={tooltip} position="up-center" hoverCardVariations={['constrained']}>
                {label}
            </Tooltip>
        );
    } else {
        return <span>{label}</span>;
    }
};
SliderFieldLabel.propTypes = {
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
};

const SliderField = props => (
    <div className="slider-field">
        <div className="slider-field__labels">
            <div className="slider-field__labels__label--min">
                <SliderFieldLabel label={props.minLabel} tooltip={props.minTooltip} />
            </div>
            <div className="slider-field__labels__label--max">
                <SliderFieldLabel label={props.maxLabel} tooltip={props.maxTooltip} />
            </div>
        </div>
        <div className="slider-field__slider">{props.children}</div>
    </div>
);
SliderField.propTypes = {
    minLabel: PropTypes.string.isRequired,
    maxLabel: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    maxTooltip: PropTypes.string,
    minTooltip: PropTypes.string,
};
SliderField.defaultProps = {
    maxTooltip: '',
    minTooltip: '',
};

const Slider = props => (
    <ReactSlider
        {...props}
        className={'slider slider--compact' + (props.disabled ? ' slider--disabled' : '')}
        handleClassName="slider__handle"
        handleActiveClassName="slider__handle--active"
    />
);
Slider.propTypes = ReactSlider.propTypes;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/sliders-element.jsx